import { Link } from 'react-router-dom';
import type { MediaItem } from '@/types/media';

interface MovieCardProps {
  item: MediaItem;
}

export default function MovieCard({ item }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-900">
        <img
          src={item.poster}
          alt={item.title}
          title={`${item.title} - 天堂影视影视海报`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-1.5 py-0.5 text-xs font-semibold text-primary-950">
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-primary-950/80 px-1.5 py-0.5 text-xs text-background-100">
          {item.type === 'movie' ? '电影' : '剧集'}
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-primary-950/0 opacity-0 transition-all duration-300 group-hover:bg-primary-950/50 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-primary-950">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {item.director} · {item.year}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900"
            >
              {g}
            </span>
          ))}
          <span className="rounded bg-background-200 px-1.5 py-0.5 text-xs text-foreground-600">
            {item.region}
          </span>
        </div>
      </div>
    </Link>
  );
}